import { Form, Card, Typography, Button, Input, Row, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { QuestionCircleOutlined } from "@ant-design/icons";
import { useLoaderData, useNavigate } from "react-router-dom";
import CollabSection from "pages/collab/CollabSection";
import { CampaignEdit } from "interfaces/campaign-edit";
import "./Campaign.scss";
import { updateCampaignDeliverables } from "services/SauceService";
import { useState } from "react";

const CampaignEditInstructions: React.FC = () => {
  const campaign = useLoaderData() as CampaignEdit;
  const [form] = useForm();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);

  const handleSubmit = async () => {
    setLoading(true);
    const { focusPoints, collabInstructions, _id } = form.getFieldsValue(true);
    const response = await updateCampaignDeliverables({
      id: _id,
      focusPoints,
      collabInstructions,
    });

    if (response) {
      message.success("Campaign instructions updated successfully");
      navigate("/campaigns");
    } else {
      message.error("Failed to update campaign instructions");
    }
    setLoading(false);
  };

  return (
    <div className="campaign create">
      <Typography.Title>Edit Campaign Instructions</Typography.Title>
      <Card style={{ borderRadius: 8 }} bordered={false}>
        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          initialValues={campaign}
        >
          <Form.Item
            required
            label={
              <span
                className="label-form"
                style={{ fontSize: 20, fontWeight: 600, marginRight: 8 }}
              >
                Brief
              </span>
            }
            tooltip={{
              title:
                "Creators will receive these instructions after they have been admitted into the collab. Describe what you would like creators to focus on. For example, mention a dish you want to highlight or a specific offer they should promote.",
              icon: <QuestionCircleOutlined />,
            }}
            className="collab-focus-points"
          >
            <span
              className="extra-label"
              style={{
                fontSize: 18,
                marginBottom: 8,
                display: "block",
                color: "#666666",
              }}
            >
              Specify highlights, including dishes or events. Instructions are
              sent to creators after they are approved into the collab.
            </span>
            <Form.Item name="focusPoints" noStyle rules={[{ required: true }]}>
              <Input.TextArea rows={5} />
            </Form.Item>
          </Form.Item>

          <Typography.Text
            style={{
              paddingBottom: 8,
              display: "block",
              fontSize: 22,
              fontWeight: 600,
            }}
          >
            Deliverables
          </Typography.Text>
          <span
            className="extra-label"
            style={{
              fontSize: 18,
              marginBottom: 24,
              display: "block",
              color: "#666666",
              lineHeight: 1.3,
            }}
          >
            Set specific instructions for each deliverable type to guide
            creators on exactly what content to create and how to promote your
            brand.
          </span>
          <CollabSection
            type="instagram-reels"
            namePrefix={["collabInstructions", "instagramReel"]}
          />
          <CollabSection
            type="instagram-story"
            namePrefix={["collabInstructions", "instagramStory"]}
          />
          <CollabSection
            type="tiktok-video"
            namePrefix={["collabInstructions", "tiktokVideo"]}
          />

          <Row
            style={{ gap: 32, marginTop: 32, justifyContent: "space-between" }}
          >
            <Button
              className="text-strong-large"
              onClick={() => navigate("/campaigns")}
            >
              Back
            </Button>
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              loading={loading}
            >
              Update
            </Button>
          </Row>
        </Form>
      </Card>
    </div>
  );
};

export default CampaignEditInstructions;
